import * as tslib_1 from "tslib";
import React, { createElement, Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import cx from 'classnames';
import withFocusedState from "../../../enhancers/withFocusedState";
import "./TextField.css";

var TextField =
/** @class */
function (_super) {
  tslib_1.__extends(TextField, _super);

  function TextField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleChange = function (event) {
      _this.props.onChange(event, event.target.value);
    };

    return _this;
  }

  TextField.prototype.renderInput = function (inputProps) {
    var _a;

    var type = inputProps.type,
        blockName = inputProps.blockName,
        inputClassName = inputProps.inputClassName,
        inputId = inputProps.inputId,
        inputRef = inputProps.inputRef,
        // we need to omit suffixProps from input, cause it's unsupported prop @lukavyi
    suffixProps = inputProps.suffixProps,
        // eslint-disable-line
    other = tslib_1.__rest(inputProps, ["type", "blockName", "inputClassName", "inputId", "inputRef", "suffixProps"]);

    var _b = this.props,
        prefix = _b.prefix,
        suffix = _b.suffix,
        hint = _b.hint;
    var componentType = type === 'textarea' ? type : 'input';
    var finalInputClassName = cx(blockName + "__input", (_a = {}, _a[blockName + "__input--with-prefix"] = prefix, _a[blockName + "__input--with-suffix"] = suffix, _a[blockName + "__input--with-hint"] = hint, _a), inputClassName);
    return createElement(componentType, tslib_1.__assign({}, other, {
      type: type === 'textarea' ? undefined : type,
      id: inputId,
      ref: inputRef,
      onChange: this.handleChange,
      className: finalInputClassName
    }));
  };

  TextField.prototype.render = function () {
    var _a;

    var _b = this.props,
        kind = _b.kind,
        tip = _b.tip,
        hint = _b.hint,
        prefix = _b.prefix,
        suffix = _b.suffix,
        isError = _b.isError,
        withBorder = _b.withBorder,
        focused = _b.focused,
        disabled = _b.disabled,
        blockName = _b.blockName,
        className = _b.className,
        tipClassName = _b.tipClassName,
        hintClassName = _b.hintClassName,
        prefixClassName = _b.prefixClassName,
        suffixClassName = _b.suffixClassName,
        readOnly = _b.readOnly,
        suffixProps = _b.suffixProps,
        other = tslib_1.__rest(_b, ["kind", "tip", "hint", "prefix", "suffix", "isError", "withBorder", "focused", "disabled", "blockName", "className", "tipClassName", "hintClassName", "prefixClassName", "suffixClassName", "readOnly", "suffixProps"]);

    var finalClassName = cx(blockName, (_a = {}, _a[blockName + "--" + kind] = kind, _a[blockName + "--error"] = isError, _a[blockName + "--active"] = focused, _a[blockName + "--disabled"] = disabled, _a[blockName + "--disabled-error"] = isError && disabled, _a[blockName + "--active-error"] = isError && focused, _a[blockName + "--with-border"] = withBorder, _a), className);
    var finalTipClassName = cx(blockName + "__tip", tipClassName);
    var finalHintClassName = cx(blockName + "__hint", hintClassName);
    var finalSuffixClassName = cx(blockName + "__suffix", suffixClassName);
    var finalPrefixClassName = cx(blockName + "__prefix", prefixClassName);

    var inputProps = tslib_1.__assign({}, other, {
      blockName: blockName,
      disabled: disabled,
      readOnly: readOnly
    });

    return React.createElement("div", {
      className: finalClassName
    }, !!prefix && React.createElement("span", {
      className: finalPrefixClassName
    }, prefix), this.renderInput(inputProps), !!tip && React.createElement("span", {
      title: tip,
      className: finalTipClassName
    }, tip), !!hint && React.createElement("span", {
      className: finalHintClassName
    }, hint), !!suffix && React.createElement("span", tslib_1.__assign({}, suffixProps, {
      className: finalSuffixClassName
    }), suffix));
  };

  TextField.propTypes = {
    tip: PropTypes.string,

    /** Available options: `default` (h=32px) and `narrow` (h=24px). */
    kind: PropTypes.string,
    hint: PropTypes.any,

    /** `type` property of `<input>` tag. */
    type: PropTypes.string,
    onCut: PropTypes.func,
    value: PropTypes.any,
    suffix: PropTypes.any,
    suffixProps: PropTypes.object,
    prefix: PropTypes.any,
    onBlur: PropTypes.func,
    onCopy: PropTypes.func,
    onPaste: PropTypes.func,

    /** `id` of native `<input>`. */
    inputId: PropTypes.string,
    inputRef: PropTypes.func,
    onFocus: PropTypes.func,
    isError: PropTypes.bool,
    withBorder: PropTypes.bool,
    focused: PropTypes.bool,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    blockName: PropTypes.string,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    tipClassName: PropTypes.string,
    hintClassName: PropTypes.string,
    suffixClassName: PropTypes.string,
    prefixClassName: PropTypes.string,
    placeholder: PropTypes.string
  };
  TextField.defaultProps = {
    kind: 'default',
    type: 'text',
    value: '',
    onCut: noop,
    onBlur: noop,
    onCopy: noop,
    onPaste: noop,
    inputRef: noop,
    isError: false,
    withBorder: true,
    focused: false,
    onFocus: noop,
    disabled: false,
    onChange: noop,
    blockName: 'nx-textfield',
    autoFocus: false,
    readOnly: false,
    suffixProps: {}
  };
  return TextField;
}(Component);

export default withFocusedState(TextField);

try {
  // @ts-ignore
  TextField.__docgenInfo = {
    "description": "",
    "displayName": "TextField",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}